import { render } from "./Frequency.vue?vue&type=template&id=4d6aeaa3&scoped=true"
import script from "./Frequency.vue?vue&type=script&lang=js"
export * from "./Frequency.vue?vue&type=script&lang=js"

import "./Frequency.vue?vue&type=style&index=0&id=4d6aeaa3&scoped=true&lang=css"
import "./Frequency.vue?vue&type=style&index=1&id=4d6aeaa3&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6aeaa3"]])

export default __exports__